/*
 * ==========================================================================
 * GRANDSTAND TRAVEL - TICKET HOLDER DETAILS
 * ==========================================================================
 *
 * UITGEBREID MET PASPOORTNUMMER EN NATIONALITEIT
 *
 * WAT ER IS TOEGEVOEGD
 *   - twee velden per tickethouder: paspoortnummer en nationaliteit
 *   - de landenlijst komt uit de browser zelf via Intl.DisplayNames, dus geen
 *     lijst van tweehonderdvijftig landen in twee talen in deze code. Wel een
 *     keuzelijst en geen tekstveld, anders krijg je NL, Nederland en Holland
 *     door elkaar en dat is bij doorgeven aan je leverancier vervelend.
 *   - validatie: allebei verplicht, paspoortnummer minimaal vijf tekens
 *
 * DE EIGENSCHAPSNAMEN BEGINNEN MET EEN UNDERSCORE
 *   '_Passport number' en '_Nationality'. Shopify verbergt eigenschappen die
 *   met een underscore beginnen voor de klant: ze staan niet in de winkelwagen,
 *   niet op de bedankpagina en niet in de bevestigingsmail. In je admin zie je
 *   ze wel gewoon bij de bestelling.
 *   Een paspoortnummer in een bevestigingsmail wil je niet, en dit kost niets.
 *   Wil je het toch zichtbaar, haal dan de underscore weg bij PROP_PASSPORT.
 *
 * NOG TE DOEN NA DE VAKANTIE
 *   1. Alleen uitvragen waar het echt nodig is, via een metafield per product.
 *      Kijk eerst of warning_1 of warning_2 van je leverancier dit al meldt.
 *   2. Bedenken hoe lang je deze gegevens bewaart en wanneer je ze opruimt
 *      uit je bestellingen.
 * ==========================================================================
 */
(function () {
  // --- Namen van de eigenschappen zoals ze bij de bestelling komen ---
  const PROP_NAME = 'Ticket holder name';
  const PROP_DOB = 'DOB';
  const PROP_PASSPORT = '_Passport number';   // underscore = verborgen voor de klant
  const PROP_COUNTRY = '_Nationality';        // underscore = verborgen voor de klant

  // Landen die bovenaan de lijst komen, want daar komt je publiek vandaan.
  const TOP_LANDEN = ['NL', 'BE', 'DE', 'GB'];

  // --- 1. VERTAAL WOORDENBOEKJE (Kijkt naar de HTML taal) ---
  const htmlLang = document.documentElement.lang || 'en';
  const isNL = htmlLang.toLowerCase().includes('nl');

  const t = {
    errCartLoad: isNL ? 'Kan winkelwagen niet laden. Vernieuw de pagina.' : 'Could not load your cart. Please refresh and try again.',
    errNoTickets: isNL ? 'Geen tickets gevonden. Voeg eerst tickets toe.' : 'No tickets found to complete. Please add your tickets first.',
    errFillInfo: isNL ? 'Vul alle gegevens in voor tickethouder ' : 'Please fill in all details for ticket holder ',
    errFutureDob: isNL ? 'De geboortedatum voor tickethouder {i} mag niet in de toekomst liggen.' : 'Date of birth for ticket holder {i} cannot be in the future.',
    errPassport: isNL ? 'Controleer het paspoortnummer van tickethouder {i}.' : 'Please check the passport number for ticket holder {i}.',
    errGeneral: isNL ? 'Er is iets misgegaan. Probeer het opnieuw.' : 'Something went wrong. Please try again.',
    lblHolder: isNL ? 'Tickethouder' : 'Ticket holder',
    lblFullName: isNL ? 'Volledige naam' : 'Full name',
    lblDob: isNL ? 'Geboortedatum' : 'Date of birth',
    lblPassport: isNL ? 'Paspoortnummer' : 'Passport number',
    lblCountry: isNL ? 'Nationaliteit' : 'Nationality',
    lblChoose: isNL ? 'Kies een land' : 'Select a country',
    hintDocs: isNL
      ? 'Deze wedstrijd vraagt om een paspoortnummer. De club heeft dit nodig om je ticket op naam te zetten.'
      : 'This match requires a passport number. The club needs it to issue your ticket in your name.',
    lblEvent: isNL ? 'Evenement' : 'Event',
    lblSelection: isNL ? 'Selectie' : 'Selection',
    lblQty: isNL ? 'Aantal' : 'Quantity',
    lblAddons: isNL ? 'Extra\'s' : 'Add-ons',
    lblSubtotal: isNL ? 'Subtotaal' : 'Subtotal'
  };

  function qs(sel, root) { return (root || document).querySelector(sel); }

  // --- Landenlijst, opgebouwd uit de browser zelf ---
  const LANDCODES = ('AD AE AF AG AI AL AM AO AR AT AU AW AZ BA BB BD BE BF BG BH BI BJ BN BO ' +
    'BR BS BT BW BY BZ CA CD CF CG CH CI CL CM CN CO CR CU CV CY CZ DE DJ DK DM DO DZ EC EE EG ' +
    'ER ES ET FI FJ FM FR GA GB GD GE GH GM GN GQ GR GT GW GY HN HR HT HU ID IE IL IN IQ IR IS ' +
    'IT JM JO JP KE KG KH KI KM KN KP KR KW KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MG ' +
    'MH MK ML MM MN MR MT MU MV MW MX MY MZ NA NE NG NI NL NO NP NR NZ OM PA PE PG PH PK PL PT ' +
    'PW PY QA RO RS RU RW SA SB SC SD SE SG SI SK SL SM SN SO SR SS ST SV SY SZ TD TG TH TJ TL ' +
    'TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VN VU WS XK YE ZA ZM ZW').split(' ');

  function landNaam(code) {
    try {
      const dn = new Intl.DisplayNames([isNL ? 'nl' : 'en'], { type: 'region' });
      return dn.of(code) || code;
    } catch (e) {
      return code;   // oude browser: dan maar de code
    }
  }

  let landenCache = null;
  function landen() {
    if (landenCache) return landenCache;

    const rest = LANDCODES
      .filter(function (c) { return TOP_LANDEN.indexOf(c) === -1; })
      .map(function (c) { return { code: c, naam: landNaam(c) }; })
      .sort(function (a, b) { return a.naam.localeCompare(b.naam, isNL ? 'nl' : 'en'); });

    const top = TOP_LANDEN.map(function (c) { return { code: c, naam: landNaam(c) }; });

    landenCache = { top: top, rest: rest };
    return landenCache;
  }

  function landOpties() {
    const l = landen();
    const maak = function (x) {
      return '<option value="' + x.code + '">' + x.naam + '</option>';
    };
    return '<option value="">' + t.lblChoose + '</option>' +
           l.top.map(maak).join('') +
           '<option disabled>──────────</option>' +
           l.rest.map(maak).join('');
  }

  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    if (!res.ok) throw new Error('cart change failed');
    return res.json();
  }

  async function addItem(variantId, properties) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, properties: properties })
    });
    if (!res.ok) throw new Error('cart add failed');
    return res.json();
  }

  function setError(el, msg) {
    el.textContent = msg;
    el.hidden = !msg;
  }

  function isFutureDate(yyyyMmDd) {
    if (!yyyyMmDd) return false;
    const d = new Date(yyyyMmDd + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return d > today;
  }

  // Bewust soepel. Paspoortnummers verschillen enorm per land, dus we
  // controleren alleen op letters en cijfers en een redelijke lengte. Te
  // streng betekent dat een geldige klant niet kan afrekenen.
  function isPassport(v) {
    const s = (v || '').replace(/[\s-]/g, '');
    return /^[A-Za-z0-9]{5,15}$/.test(s);
  }

  function buildRow(i) {
    const wrap = document.createElement('div');
    wrap.className = 'gt-th__row';
    wrap.innerHTML = `
      <p class="gt-th__row-head">${t.lblHolder} ${i}</p>

      <div class="gt-th__field">
        <label class="gt-th__label" for="gt_th_name_${i}">${t.lblFullName}</label>
        <input class="gt-th__input" id="gt_th_name_${i}" type="text" autocomplete="name" placeholder="${t.lblFullName}">
      </div>

      <div class="gt-th__field">
        <label class="gt-th__label" for="gt_th_dob_${i}">${t.lblDob}</label>
        <input class="gt-th__input" id="gt_th_dob_${i}" type="date" autocomplete="bday">
      </div>

      <div class="gt-th__field">
        <label class="gt-th__label" for="gt_th_pass_${i}">${t.lblPassport}</label>
        <input class="gt-th__input" id="gt_th_pass_${i}" type="text"
               inputmode="text" autocapitalize="characters" autocomplete="off"
               spellcheck="false" placeholder="${t.lblPassport}">
      </div>

      <div class="gt-th__field">
        <label class="gt-th__label" for="gt_th_country_${i}">${t.lblCountry}</label>
        <select class="gt-th__input gt-th__select" id="gt_th_country_${i}" autocomplete="off">
          ${landOpties()}
        </select>
      </div>
    `;
    return wrap;
  }

  function readRows(count) {
    const out = [];
    for (let i = 1; i <= count; i++) {
      const name = (qs('#gt_th_name_' + i).value || '').trim();
      const dob = (qs('#gt_th_dob_' + i).value || '').trim();
      const pass = (qs('#gt_th_pass_' + i).value || '').trim().toUpperCase();
      const landEl = qs('#gt_th_country_' + i);
      const land = (landEl.value || '').trim();
      const landTekst = land ? landEl.options[landEl.selectedIndex].text : '';
      out.push({ name: name, dob: dob, passport: pass, country: land, countryName: landTekst });
    }
    return out;
  }

  function validate(attendees) {
    for (let i = 0; i < attendees.length; i++) {
      const a = attendees[i];
      if (!a.name || !a.dob || !a.passport || !a.country) {
        return { ok: false, msg: t.errFillInfo + (i + 1) + '.' };
      }
      if (isFutureDate(a.dob)) {
        return { ok: false, msg: t.errFutureDob.replace('{i}', i + 1) };
      }
      if (!isPassport(a.passport)) {
        return { ok: false, msg: t.errPassport.replace('{i}', i + 1) };
      }
    }
    return { ok: true, msg: '' };
  }

  function findTargetLine(cart) {
    return cart.items.find((it) => {
      const props = it.properties || {};
      const requires = props['_gt_requires_holders'] === '1';
      const hasName = !!props[PROP_NAME];
      const hasDob = !!props[PROP_DOB];
      return requires && (!hasName || !hasDob);
    }) || null;
  }

  function money(cents) {
    const format = (window.Shopify && Shopify.money_format) ? Shopify.money_format : '€{{amount}}';
    const value = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', value)
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','));
  }

  function renderSummary(cart, target) {
    const box = document.querySelector('.gt-th__summary');
    const body = document.querySelector('.gt-th__summary-body');
    if (!box || !body) return;

    const eventTitle = target.product_title || 'Tickets';
    const variantTitle = target.variant_title || '';

    const addons = cart.items.filter((it) => {
      const props = it.properties || {};
      return props['_gt_requires_holders'] !== '1';
    });

    const rows = [];

    rows.push({ label: t.lblEvent, value: eventTitle });
    if (variantTitle) rows.push({ label: t.lblSelection, value: variantTitle });
    rows.push({ label: t.lblQty, value: String(target.quantity) });

    if (addons.length) {
      const addonText = addons
        .map((a) => `${a.product_title}${a.quantity > 1 ? ` ×${a.quantity}` : ''}`)
        .join(', ');
      rows.push({ label: t.lblAddons, value: addonText });
    }

    rows.push({ label: t.lblSubtotal, value: money(cart.items_subtotal_price) });

    body.innerHTML = rows.map((r) => `
      <div class="gt-th__summary-row">
        <span class="gt-th__summary-label">${r.label}</span>
        <span class="gt-th__summary-value">${r.value}</span>
      </div>
    `).join('');

    box.hidden = false;
  }

  async function init() {
    const listEl = qs('.gt-th__list');
    const btn = qs('.gt-th__continue');
    const errorEl = qs('.gt-th__error');

    if (!listEl || !btn) return;

    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      setError(errorEl, t.errCartLoad);
      return;
    }

    const target = findTargetLine(cart);

    if (!target) {
      setError(errorEl, t.errNoTickets);
      btn.disabled = true;
      return;
    }

    const qty = target.quantity;

    renderSummary(cart, target);

    listEl.innerHTML = '';

    // Uitleg waarom je om een paspoortnummer vraagt. Zonder reden voelt zo'n
    // veld als overvragen en haken mensen af.
    const uitleg = document.createElement('p');
    uitleg.className = 'gt-th__docs-hint';
    uitleg.textContent = t.hintDocs;
    listEl.appendChild(uitleg);

    for (let i = 1; i <= qty; i++) listEl.appendChild(buildRow(i));

    btn.addEventListener('click', async function () {
      setError(errorEl, '');

      const attendees = readRows(qty);
      const v = validate(attendees);
      if (!v.ok) {
        setError(errorEl, v.msg);
        return;
      }

      btn.disabled = true;

      try {
        await changeLine(target.key, 0);

        for (let i = 0; i < qty; i++) {
          const props = {
            '_gt_requires_holders': '1'
          };
          props[PROP_NAME] = attendees[i].name;
          props[PROP_DOB] = attendees[i].dob;
          props[PROP_PASSPORT] = attendees[i].passport;
          props[PROP_COUNTRY] = attendees[i].countryName + ' (' + attendees[i].country + ')';

          await addItem(target.variant_id, props);
        }

        window.location.href = '/checkout';
      } catch (e) {
        console.error(e);
        setError(errorEl, t.errGeneral);
      } finally {
        btn.disabled = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();